import BlueOrangeRed from './blue-orange-red.es.js';
import BlueVioletRedOrange from './blue-violet-red-orange.es.js';
import GreenOrangeViolet from './green-orange-violet.es.js';
import PurpleBlueRed from './purple-blue-red.es.js';
import RedPurpleGreen from './red-purple-green.es.js';
import VioletBlueGreen from './violet-blue-green.es.js';

var flooded = {
    GreenOrangeViolet,
    VioletBlueGreen,
    BlueVioletRedOrange,
    BlueOrangeRed,
    PurpleBlueRed,
    RedPurpleGreen
};

export { flooded as default };
//# sourceMappingURL=index.es.js.map
